//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import CheckIcon from 'vux/src/components/check-icon/index.vue';
import XAddress from 'vux/src/components/x-address/index.vue';
import XDialog from 'vux/src/components/x-dialog/index.vue';
import XInput from 'vux/src/components/x-input/index.vue';
import Group from 'vux/src/components/group/index.vue';
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex';
import filters from '../filters/index';
import * as utils from '../utils/index';
import * as CONSTANTS from '../constants/index';
import { stat } from 'fs';
import KeyBoard from '../components/KeyBoard';
import ZhinengKefu from '../components/ZhinengKefu';
import memberModule from '@/common/memberModule';
import SNKH5Uploader from 'snk-image-js/lib/h5/uploader'
import JumpHaShop from './../components/JumpHaShop.vue'
const cloudImageBaseURL = process.env.VUE_APP_CLOUDIMAGE_API_URL
// import { Loading } from 'vant';


export default {
  name: 'home',
  data(){
    return{
      licenseNo: this.$route.query.licenseNo || '京A',//修改车牌号全部用setLicenseKB ,避免重复监听
      newCar:false,
      showDialog:false,
      dialogContent:"",
      certainButton:"",
      cancelButton:"",
      value:[],
      addressData:[],  
      wrongMsg:"车牌号码有误，请重新输入",
      wrongFlag:false,
      carBeans:utils.deepClone(CONSTANTS.CAR_BEANS),
      isTemp:Boolean,
      cityID:'',
      carFlag:false,
      saveData:{},
      isAutoPosition:true,
      flowId:'',
      disabledInput:false,
      skipReason: '',
      isShowTips:false,
      tabActive: 0,
      showAddress: false,
      cityName: '',
      isNotClick: true,
      jcnrLeft: [
        {imgName: 'jcnr1.png', label: '小课堂', text: '三者险有多重要！', link: 'https://m.sinosafe.com.cn/eb-web/vue/img-text/#/details/C-C9B8A24620A13B40E0536CCB010AC901'},
        {imgName: 'jcnr2.png', label: '保险小课堂', text: '【车险微服务】疫情“不见面”，理赔“更方便”！', link: 'https://mp.weixin.qq.com/s/IsU7prD1Dbyjh8YKxlMFWw'},
      ],
      jcnrRight: [
        {imgName: 'jcnr3.png', label: '专栏', text: '保险助您规避撞豪车风险？', link: 'https://m.sinosafe.com.cn/eb-web/vue/img-text/#/details/C-9525E4A4E92759DCE0536CCB010A4E99'},
        {imgName: 'jcnr4.png', label: '专栏', text: '一图读懂！华安保险2021车险人伤管家服务质量报告', link: 'https://mp.weixin.qq.com/s/CtDqxZYMrD9y0eDepeB31A'},
        {imgName: 'jcnr5.png', label: '专栏', text: '三者险必须买够！5月起新标准执行，“同命不同价”现象终结', link: 'https://mp.weixin.qq.com/s/ThPmwK3drdmjyURfACruqQ'},
      ],
      orgin:this.$route.query.orgin,
      isCanDept: false,
      offSiteVehicleLicenseNo:'',//异地车牌判断
      isManualSelect:false,//手动选择地址
      isAutoEditLicenseNo:false,//是否自动填充车牌
      isGoLogin:false,
      toLoginSecond:3,//弹框倒计时读秒
      switchList:'',//开关
      timeEvent: '',
      urlParams: {},
      sdCityId: '',
      sdReqDone: false, // 山东营运接口是否请求结束
      isHaApp: !!window.navigator.userAgent.match(/HaApp|uni-app/ig), // 是否华安保险app
      isShowSdjgMember: false, // 山东营运车：是否展示跳转华安保险公众号订单中心
    }
  },
  created(){

  },
  mounted(){
    const params = utils.getParams()
    const url = decodeURIComponent(window.location.href);
    
    const signature = params && params.signature || ''
    const vehicleid = params && params.vehicleid || ''
    const isSdjg = url.includes('signature') && url.includes('vehicleid')
    // 是否山东营运车
    this.setSdjg(Boolean(isSdjg))
    // 山东营运车带过来的参数
    this.urlParams = {
      signature,
      vehicleid
    }
    if (window.location.href.includes('cartype=hc')) {
      this.$vux.confirm.show({
        title: '温馨提示',
        content: '暂不支持您爱车线上投保，请访问线下门店投保。',
        showConfirmButton: false,
        showCancelButton: false
      })
      return
    }

    // 初始化时清空地址
    this.setBaseAddress('')
    let self = this;
    this.$set(this,'isShowTips',true)
    this.carBeans=this.quoteInfo;
    this.newCar=this.isNewCar;
    // if(this.cityList.length==0){
    //   $get.wxCityQuery()
    //   .then(res=>{
    //     if(res.resultCode=='0'){  
    //       this.addressData=res.result;
    //       this.getLocation();
    //     }
    //   });
    // }else{
    //   this.addressData=this.cityList;
    //   if (!this.value.length) {
    //     this.value=this.cityGroup;
    //   }
    // }

    // memberModule.checkLogin(res => {
    //   this.$store.commit('setUserInfo', res);
    //   Object.assign(this.carBeans.insured, res);
    //   this.setOwnerInfo();
    //   this.getCarInfo();
    // }, () => {
    //   self.$set(self,'isGoLogin',true)
    //   self.timeEvent = setInterval(()=>{
    //     self.$set(self,'toLoginSecond',self.toLoginSecond-1)
    //     if(self.toLoginSecond<1){
    //       clearInterval(t);
    //       memberModule.toLogin();
    //     }
    //   },1000) 
      
    // });

    /**
     * 二次进来直接请求
     * 先弹框可回溯提示，点击确认后再弹框登录倒计时，登录后再获取定位。登录成功后不重复弹可回溯提示
     * */
    let href = window.location.href;
    if (href.includes('hasLogin=true')) {
      this.$set(this, 'isShowTips', false);
      memberModule.checkLogin(res => {
        // 公共系统埋点统计
        let recordCode = this.isHaApp ? 'gEmS4zbaaGYpbCsTrIsje' : 'xBHY98f0sF8zVbh5cXnIs'
        $http.addRecord({data: { recordCode }})
        this.$store.commit('setUserInfo', res);
        Object.assign(this.carBeans.insured, res);
        // this.initToGetFlowId();
        this.setOwnerInfo();
        this.getCarInfo();
        this.queryLocation(); // 获取定位
        if (this.isSdjg) {
          this.getSdQuoteData()
        }
      }, () => {},()=>{},{ headers: { 'X-Desensitize': false } });
    }
    if(!href.includes('hasLogin=true')){
      this.initToGetFlowId();
    } else {

      let flowId = window.sessionStorage.getItem('flowId');
      this.setFlowId(flowId);
      this.flowId = flowId;
      setTimeout(()=> {
        utils.startVideo('', flowId, (isSuccess) => {
            if(isSuccess){
                // this.$store.commit('setIsStartVideo', true);
                utils.createOperationVideo("LOAD_PAGE","填写信息");
            }
        })
      }, 500)
    }

    // const homeEl = document.querySelector('.home');
    // const tabEl = homeEl.querySelector('.tab');
    // this.tabElOffsetTop = tabEl.offsetTop
    // window.addEventListener("scroll", this.handleScolll, true)
    
    // this.$store.commit('setIsStartVideo', false);
    this.$nextTick(()=>{
      window.addEventListener('scroll',this.scrollToActiveTap,true)
    })
    // window.sessionStorage.removeItem('flowId');
  },
  components: {
    CheckIcon,
    XDialog,
    XAddress,
    XInput,
    Group,
    KeyBoard,
    ZhinengKefu,
    JumpHaShop
  },
  computed:{
    ...mapGetters(['getLicenseKB']),
    ...mapState({
      quoteInfo: state => state.quote.quoteInfo,
      cityList: state => state.cityList,
      cityGroup: state => state.cityGroup,
      isNewCar: state => state.isNewCar,
      insuredTips: (state) => state.insuredTips,
      applicantTips: (state) => state.applicantTips,
      isHc: state => state.isHc,
      isSdjg: state => state.isSdjg, // 山东营运车辆
      sdQuoteInfo: state => state.quote.sdQuoteInfo
    }),
  },
  watch:{
    getLicenseKB(val) {
        //修改车牌号全部用setLicenseKB ,避免重复监听
        this.carBeans.vehicle.licenseNo = val;
        this.clearCacheRecordInfo()
        if(!this.isAutoEditLicenseNo){
          this.carBeans.vehicle.frameNo = '';
          this.carBeans.vehicle.singeinDate = '';
          this.carBeans.vehicle.brandName = '';
          this.carBeans.vehicle.engineNo = '';
        }
        this.isAutoEditLicenseNo = false;
    },

    'carBeans.vehicle.licenseNo':{
      handler(newName, oldName) {
        this.carFlag=true;
      },
      immediate: true,
      deep: true
    },
    newCar:{
      handler(newName) {
        if(newName){
          this.disabledInput=true;
        }else{
          this.disabledInput=false;
        }
      },
      immediate: true,
      deep: true
    },
    value: {
        handler(newValue, oldValue){
            let flag = false;
            if (newValue && newValue.length && oldValue) {
                if (newValue.length !== oldValue.length) {
                    if (newValue.length > 1) {
                        flag = true
                    }
                } else {
                    if (newValue.length > 1 && oldValue.length > 1 && newValue[2] !== oldValue[2]) {
                        flag = true
                    }
                }
            }
            if (flag) {
                const selectCityObj = (this.addressData && this.addressData.find((item) => item.value === newValue[1])) || {}
                this.cityName = selectCityObj.name;
                this.queryDeptByCity()
            }
        }
    }

  },
  methods:{
    ...mapMutations({
      setCityList: 'setCityList',
      setFlowId:'setFlowId',
      setQuoteInfo:'quote/setQuoteInfo',
      setInitQuoteInfo: 'quote/setInitQuoteInfo',
      setCityGroup:'setCityGroup',
      setNewCar:'setNewCar',
      setDeptCode:'setDeptCode',
      openKB:'openKB',
      hideKB:'hideKB',
      setLicenseKB:'setLicenseKB',
      setSwitchList:'quote/setSwitchList',
      setIsDigital:'quote/setIsDigital',
      setApplicantEmail: 'quote/setApplicantEmail',
      setCacheRecordInfo: 'quote/setCacheRecordInfo',
      clearCacheRecordInfo: 'quote/clearCacheRecordInfo',
      setInsuredTips: 'setInsuredTips',
      setApplicantTips: 'setApplicantTips',
      setBaseAddress: 'quote/setBaseAddress',
      setIsHc: 'setIsHc',
      setSdjg: 'setSdjg',
      setSdQuoteInfo: 'quote/setSdQuoteInfo'
    }),
    plateFocus() {
      if (this.isSdjg) return;
      if(!this.newCar){
        this.openKB();
        
      }
      
    },
    newCarClick(value) {
      if (this.isSdjg) return;
      this.newCar = value;
    },
    clickBody(e) {
      this.hideKB();
    },
    onClose(){
      //地址选择弹框关闭事件
      this.isManualSelect = true;//手动选择
    },
    onShadowChange(ids,names) {
      this.cityID=utils.deepClone(ids).pop();
    //   if(!this.isAutoPosition){return}
    // this.isAutoPosition = false;
      

    },
    loadLocation(){
      let vm = this;
      let geolocation = new window.qq.maps.Geolocation();
      geolocation.getLocation(showPosition, showErr);
      function showPosition(position) {
        let addComp = position;
        if(addComp.adcode){         
            let n2v = utils.name2value(addComp.province,addComp.city,addComp.district,vm.addressData);
            // console.log(n2v);
            vm.cityID = utils.deepClone(n2v.address).pop();
            if (!vm.value.length) {
              vm.value=n2v.address;
              this.isManualSelect = false;//自动选择
            }
            if(!n2v.flag){
                Toast(n2v.errMsg || errmsg.error);
            }
        }else{
          Toast('定位失败，请手动输入');
        }
        Loading.hide();
      };

      function showErr(res) {
        Loading.hide();
        // console.log(res);
        Toast('定位失败，请手动输入');
      };

    },
    async quoteInit(data,type){
      let that = this;
      if(this.orgin !== '00017' && this.orgin !== '000174' && !this.isSdjg){
        this.isCanDept = true;
        return;
      }
      // window.sessionStorage.removeItem('flowId');
      if(type==='quoteTop'){
        _hmt.push(['_trackEvent', 'quoteTop', 'click']);
      }else if(type==='quoteBottom'){
        _hmt.push(['_trackEvent', 'quoteBottom', 'click']);
      }
      if (!this.value || (this.value && this.value.length === 0)) {
        Toast('请选择城市');
        return;
      }
      this.setCityList(this.addressData);
      this.setCityGroup(this.value);
      let tempNo=JSON.parse(window.localStorage.getItem('tempNoInfo'));
      // console.log(tempNo);
      let reg=/^[\u4e00-\u9fa5]{1}[A-Za-z]{1}[A-Za-z_0-9]{4}([\u4e00-\u9fa5]|[A-Za-z0-9]){1,4}?$/;
      let regMoto = /^(?=(^[\u4e00-\u9fa5]+[A-Za-z0-9]+|[\u8b66]{1}$)).{7,10}$/;
      sessionStorage.removeItem('imgIdListHistory')
      if(!this.newCar ){
        if(!reg.test(data.licenseNo) || !regMoto.test(data.licenseNo)){
          this.wrongFlag=true;
          return
        }  else{
          this.wrongFlag=false;
        }
      }else{
        data.licenseNo='*-*';
        this.wrongFlag=false;
      }
      // 【行协】河南货车便民投保链接 240716
      let href = window.location.href;
      if (href.includes('cartype=hc')) {
        this.setIsHc(true)
      }
      let cityid = this.cityID
      if (this.isSdjg) {
        cityid = this.sdCityId
      }
      if(this.carFlag){
        // tudo
        $http.quoteInit({
          data: {
            cityid,
            licenseNo: data.licenseNo,
            systemSource: 1,
            vehicleid: this.isSdjg ? data.vehicleid || '' : '',
          },
          query:{
            // 可回溯视频优化需求此接口需要携带flowId
            flowId: this.flowId,
          }
        }).then(res=>{
          if(res.resultCode='0'){
            if(res.errorMsg){
              Toast(res.errorMsg);
            }
            this.setFlowId(res.result);
            this.flowId=res.result;
            window.sessionStorage.setItem('flowId', res.result);
            $get.officialApply({
                query:{
                    flowId: this.flowId,
                }
            }).then(async res=>{
                if(res.resultCode=='0'){
                  const switchList = await $http.getAllSwitch({
                    data: {
                      dptNo: res.result.base.companyCode,
                      channelNo: 'b2b',
                    }
                  })
                  if(switchList.code=='0'){
                    this.setSwitchList(switchList.data)
                    this.$set(this,'switchList',switchList.data)
                    // 230523去除新转保总开关管控
                    if(switchList.data.canInsuredDeptMobSwitch === '1') {
                      //机构允许投保开关
                      if(switchList.data.newCarNoInsurance === '1' && data.licenseNo == '*-*'){
                        // 新车不允许出单开关管控
                        this.isCanDept = true
                        return;
                      }
                      if(switchList.data.offSiteVehicleSwitch === '1' && data.licenseNo !== '*-*'){
                        // 异地车牌禁止投保开关
                        let offSiteVehicleLicenseNo = window.sessionStorage.getItem('offSiteVehicleLicenseNo')||'';
                        if(data.licenseNo.slice(0,1) != offSiteVehicleLicenseNo.slice(0,1)) {
                          this.isCanDept = true
                          return;
                        }
                      }
                    } else {
                      // 不允许投保机构，3秒自动跳转线下门店
                      this.isCanDept = true;
                      // setTimeout(()=>{
                      //   that.routeJump()
                      // },3000)
                      return;
                    }
                  }
                  $get.checkDigitalByCompany({
                    query: {
                      companyCode: res.result.base.companyCode
                    }
                  }).then(res=>{
                    if(res.resultCode=='0'){
                        // 设置机构是否开通数电标识
                        if (res.result) {
                          this.setIsDigital(1)
                        } else {
                          this.setIsDigital(2)
                        }
                    }
                  }).catch(err=>{
                    // console.log(err, 'err');
                    this.setIsDigital(0)
                  })
                  let DEPTCODE=utils.deepClone(res.result.base.companyCode).substr(0, 4);
                  this.setDeptCode(DEPTCODE);
                  // 每分钟发送一次心跳 保持联通
                  setInterval(function(){
                    $get.heartBeat({
                      showLoading: false,
                      closeLoading: false,
                    });
                  }, 60000);
                /*  let carObj=utils.mergeObj(this.carBeans.vehicle,res.result.vehicle,utils.deepClone(CONSTANTS.CAR_BEANS.vehicle));
                 this.carBeans.vehicle=carObj; */
                  this.carBeans = utils.mergeCarBeans(this.carBeans, res.result);
                  // console.log(JSON.parse(JSON.stringify(this.carBeans)),'------')
                  this.carBeans = utils.mergeCarBeans(utils.deepClone(CONSTANTS.CAR_BEANS), this.carBeans);
                  // console.log(JSON.parse(JSON.stringify(this.carBeans)),'+++++')
                  // 保存初始化carBeans信息
                  // this.setInitQuoteInfo(res.result);             
                  if(!this.newCar){
                    chooseProject(tempNo);
                  } else{ 
                    // 山东营运车：仓库存平台数据，不能用当前页面carBeans覆盖
                    if (!this.isSdjg) {
                      this.setQuoteInfo(this.carBeans);
                    }
                    this.setNewCar(this.newCar);
                    // console.log('home.quoteInfo!!!!!',this.quoteInfo);
                    if (this.isSdjg) {
                      this.$router.push({path: '/base_msg_sd'});
                      return;
                    }
                    if (this.isHc) {
                      this.$router.push({path: '/base_msg_hc'});
                      return;
                    }
                    if(this.switchList.ocrInsuredSwitch){
                      this.$router.push({path: '/base_msg_ocr'});
                      return ; 
                    }
                    this.$router.push({path: '/base_msg'}); 
                  }
                }else{
                  Toast(res.errorMsg);
                }
                // console.log(res);
            })
            
          }else{
            Toast(res.errorMsg);
          }
        })
      }else{
        if (this.isSdjg) {
          this.$router.push({path: '/base_msg_sd'});
          return;
        }
        if (this.isHc) {
          this.$router.push({path: '/base_msg_hc'});
          return;
        }
        if(this.switchList.ocrInsuredSwitch){
          this.$router.push({path: '/base_msg_ocr'});
          return ; 
        }
        this.$router.push({path: '/base_msg'}); 
      }
      


      let chooseProject=(tempNo)=>{
        if(tempNo && tempNo[this.carBeans.vehicle.licenseNo]){
          $get.tempNoQuery({
            params:[tempNo[this.carBeans.vehicle.licenseNo]]
          }).then(res=>{
            // console.log(res);
            if(res.resultCode=='0'){
              const riskList = res.result.riskList
              const f1 = !riskList
              const f2 = riskList && !riskList.length
              const f3 = riskList && riskList.length && riskList.every(item => !item.imageId)
              const flag = f1 || f2 || f3
              // 山东营运车: 不走ocr页面
              if(!this.isSdjg){
                if(this.switchList.ocrInsuredSwitch && flag) {
                  this.$router.push({path: '/base_msg_ocr'});
                  return ; 
                }
              }
              this.isTemp=true;
              this.dialogContent='系统检测到您这个车牌上次有未填写完的订单，是否继续上次的投保';
              this.certainButton='继续上一次投保';
              this.cancelButton='不用了，重新填写';
              this.showDialog=true;
              this.saveData=res.result;
              if (!this.isSdjg) {
                this.saveData.base = res.result.base; //220621 使用本次选择的销售信息
                this.saveData.base.cityCode = this.carBeans.base.cityCode
                this.saveData.base.cityName = this.carBeans.base.cityName
                this.saveData.base.deptCode = this.carBeans.base.deptCode
                this.saveData.base.deptCodeName = this.carBeans.base.deptCodeName
                this.saveData.base.operatorCode = this.carBeans.base.operatorCode
                this.saveData.base.operatorName = this.carBeans.base.operatorName
                this.saveData.base.regionalCode = this.carBeans.base.regionalCode
                this.saveData.base.regionalName = this.carBeans.base.regionalName
                this.saveData.base.salesCode = this.carBeans.base.salesCode
                this.saveData.base.salesMobile = this.carBeans.base.salesMobile
                this.saveData.base.salesName = this.carBeans.base.salesName
                this.saveData.base.origSysName = this.carBeans.base.origSysName
                this.saveData.base.origSys = this.carBeans.base.origSys
              }else{
                this.saveData.base = this.sdQuoteInfo.base; // 用山东运营车返回的数据
              }
              this.skipReason = "Continue-Last-Quote";
            }else{
              // 山东营运车：仓库存平台数据，不能用当前页面carBeans覆盖
              if (!this.isSdjg) {
                this.setQuoteInfo(this.carBeans);
              }
              this.setNewCar(this.newCar);
              if (this.isSdjg) {
                this.$router.push({path: '/base_msg_sd'});
                return;
              }
              if (this.isHc) {
                this.$router.push({path: '/base_msg_hc'});
                return;
              }
              if(this.switchList.ocrInsuredSwitch){
                this.$router.push({path: '/base_msg_ocr'});
                return ; 
              }
              this.$router.push({path: '/base_msg'});
            }
          })
        }else{
          // 【行协】河南货车便民投保链接 240716
          let href = window.location.href;
          if (!this.isSdjg) {
            this.setQuoteInfo(this.carBeans);
          }
          this.setNewCar(this.newCar);
          if (this.isSdjg) {
            this.$router.push({path: '/base_msg_sd'});
            return;
          }
          if (this.isHc) {
            this.$router.push({path: '/base_msg_hc'});
            return;
          }
          if(this.switchList.ocrInsuredSwitch){
            this.$router.push({path: '/base_msg_ocr'});
            return ; 
          }
          this.$router.push({path: '/base_msg'});
          // $http.renewal({
          //   data:{
          //     licenseNo:data.licenseNo,
          //     insuredProduct: href.includes('cartype=hc') ? '0' : '1'// 【行协】河南货车便民投保链接 240716
          //   },
          //   query:{
          //     flowId: this.flowId,
          //   }
          // }).then(res=>{
          //   // console.log(res);
          //   if(res.resultCode=='0'){
          //     // const riskList = res.result.riskList
          //     // const f1 = !riskList
          //     // const f2 = riskList && !riskList.length
          //     // const f3 = riskList && riskList.length && riskList.every(item => !item.imageId)
          //     // const flag = f1 || f2 || f3
          //     // if(this.switchList.ocrInsuredSwitch && flag) {
          //     //   this.$router.push({path: '/base_msg_ocr'});
          //     //   return ; 
          //     // }
          //     this.isTemp=false;
          //     this.dialogContent='系统检测到该车牌曾经投保过，是否直接去续保？只需输入身份证号即可免除信息重复录入，30s内即可为您的爱车投保，更加快捷简便哦~';
          //     this.certainButton='好的，去续保';
          //     this.cancelButton='不用了，继续投保';
          //     this.showDialog=true;
          //     this.skipReason = "Renewal-Of-Insurance";
          //   }else{
          //     this.setQuoteInfo(this.carBeans);
          //     this.setNewCar(this.newCar);
          //     if (this.isHc) {
          //       this.$router.push({path: '/base_msg_hc'});
          //       return;
          //     }
          //     if(this.switchList.ocrInsuredSwitch){
          //       this.$router.push({path: '/base_msg_ocr'});
          //       return ; 
          //     }
          //     this.$router.push({path: '/base_msg'});
          //   }
          // })
        }
      }
      
      
    },
    toCallInsured(){
      _hmt.push(['_trackEvent', 'toInsured', 'click']);
      let url = window.location.host=='m.sinosafe.com.cn'?'https://m.sinosafe.com.cn/eb-web/vue/activities/phoneCover.html#/insure':'https://mtest.sinosafe.com.cn/eb-web/vue/activities/phoneCover.html#/insure';
      let href = url +'?orgin='+ this.orgin +'&licenseNo=' + encodeURIComponent(this.carBeans.vehicle.licenseNo ||'');
      window.location.href = href;
    },
    filterLicenseNo(e){
      let val  = e.target.value;
      if (!val){
        this.carBeans.vehicle.licenseNo = ''
      } else{
          val = val.toString()
          this.carBeans.vehicle.licenseNo = val.toUpperCase();
      }
    },
    quoteCancel(){
      this.showDialog=false;
      if (this.skipReason === 'Continue-Last-Quote' && !this.isSdjg) {
        // 非山东便民投保 走这里
        // 点击【不用了，重新填写】,清除历史数据
        let _base = (this.carBeans && this.carBeans.base) || utils.deepClone(CONSTANTS.CAR_BEANS.base); // 保留base 终端来源 销售信息
        let _licenseNo = (this.carBeans && this.carBeans.vehicle && this.carBeans.vehicle.licenseNo) || ''; // 保留车牌号
        let _mobilePhone = (this.carBeans && this.carBeans.owner && this.carBeans.owner.mobilePhone) || ''; // 保留手机号
        this.carBeans = utils.deepClone(CONSTANTS.CAR_BEANS);
        this.carBeans.base = _base;
        this.carBeans.vehicle.licenseNo = _licenseNo;
        this.carBeans.owner.mobilePhone = _mobilePhone;
      }
      this.setNewCar(this.newCar);
      if(this.isSdjg){
        this.setQuoteInfo(this.sdQuoteInfo);
        this.$router.push({path: '/base_msg_sd'});
        return;
      }else{
        this.setQuoteInfo(this.carBeans);
      }
      if (this.isHc) {
        this.$router.push({path: '/base_msg_hc'});
        return;
      }
      if(this.switchList.ocrInsuredSwitch){
        //清空ocr图片数据
        this.clearCacheRecordInfo()
        // 清除同车主msg
        this.setInsuredTips('')
        this.setApplicantTips('')
        this.$router.push({path: '/base_msg_ocr'});
        return ; 
      }
      this.$router.push({path: '/base_msg'});
    },
    // 获取影像token
    getTokenToImageUpload() {
      // 影像id
      const imageIds = this.saveData.riskList.map((item) => item.imageId)
      // 上传目录
      const imageItemInfos = [
        {
          // 投保人信息目录
          type: '1',
          itemName: this.saveData.applicant.name || this.quoteInfo.owner.name,
          itemNumber: this.saveData.applicant.identifyNumber || this.quoteInfo.owner.identifyNumber,
          itemType: this.saveData.applicant.identifyType || this.quoteInfo.owner.identifyType
        },
        {
          // 被保人信息目录
          type: '2',
          itemName: this.saveData.insured.name || this.quoteInfo.owner.name,
          itemNumber: this.saveData.insured.identifyNumber || this.quoteInfo.owner.identifyNumber,
          itemType: this.saveData.insured.identifyType || this.quoteInfo.owner.identifyType
        },
        {
          // 车主信息目录
          type: '4',
          itemName: this.saveData.owner.name,
          itemNumber: this.saveData.owner.identifyNumber,
          itemType: this.saveData.owner.identifyType,
        },
        {
          // 车辆信息目录
          type: '5',
          itemName: this.saveData.vehicle.licenseNo,
          itemNumber: this.saveData.vehicle.frameNo,
        },
      ]
      const data = {
        companyCode: this.saveData.base.companyCode || '',
        imageIds,
        imageItemInfos,
        operator: this.saveData.base.operatorCode || '',
        proposalNo: '',
        step: '投保补传',
      }
      const option = {
        data,
      }
      return $http
        .getImageToken(option)
        .then((res) => {
          if (res.resultCode == '0') {
            return res.result.token
          } else {
            Toast(res.errorMsg || '获取token失败')
          }
        })
        .catch((err) => {
          Toast(res.errorMsg || '获取token失败')
          console.log(err)
        })
    },
    // 初始化SDK
    initUploaderInstance() {
      return new Promise((resolve, reject) => {
        const vm = this
        const uploaderInstance = new SNKH5Uploader({
          api: {
            base: cloudImageBaseURL,
            // base: 'https://h5file.sinosafe.com.cn/h5img', // 正式
          },
          getToken: function(params) {
            vm.getTokenToImageUpload().then((token) => {
              vm.uploadToken = token
              params.success({
                token
              })
            })
          },
        })
        uploaderInstance.init({
          success: function() {
            uploaderInstance.queryFiles({
              // imgIdList: [], 为空数组的时候返回改业务号下的所有文件信息
              imgIdList: [],
              success: res => {
                resolve(res)
              },
              error: error => {
                console.log(error)
              }
            })
            console.log('success')
          },
          error: function(e) {
            console.log(e)
          },
        })
        vm.uploaderInstance = uploaderInstance
      })
    },
    // 初始化获取flowId
    initToGetFlowId() {
      $get
        .initToGetFlowId()
        .then((res) => {
          if (res.resultCode==='0' && res.result) {
            const data = res.result
            this.setFlowId(data.flowId);
            window.sessionStorage.setItem('flowId',data.flowId);
            this.flowId = data.flowId
            setTimeout(() => {
              utils.startVideo(1, data.flowId, (isSuccess) => {
                  if(isSuccess){
                      // this.$store.commit('setIsStartVideo', true);
                      utils.createOperationVideo("LOAD_PAGE","填写信息");
                  }
              })
            }, 500)
          } else {
            Toast(res.errorMsg || '获取flowId失败')
          }
        })
        .catch((err) => {
          Toast(res.errorMsg || '获取flowId失败')
          console.log(err)
        })
    },
    getImgData() {
      this.initUploaderInstance().then((imgData) => {
        const cacheRecordInfo = {
          owner: {
            name: '',
            identifyNumber: '',
            identifyExpiry: '',
            birthday: '',
            justSrc: '',
            backSrc: ''
          },
          insured: {
            name: '',
            identifyNumber: '',
            identifyExpiry: '',
            birthday: '',
            justSrc: '',
            backSrc: '',
          },
          applicant: {
            name: '',
            identifyNumber: '',
            identifyExpiry: '',
            birthday: '',
            justSrc: '',
            backSrc: '',
          },
          vehicle: {
            licenseNo: '',
            brandName: '',
            frameNo: '',
            singeinDate: '',
            engineNo: '',
            justSrc: '',
            backSrc: '',
          },
        }
        const arr = ['name', 'identifyNumber', 'identifyExpiry', 'birthday']
        const applicant = this.saveData.applicant || {}
        const owner = this.saveData.owner || {}
        const insured = this.saveData.insured || {}
        const vehicle = this.saveData.vehicle || {}
        cacheRecordInfo.vehicle.licenseNo = vehicle.licenseNo
        cacheRecordInfo.vehicle.brandName = vehicle.brandName
        cacheRecordInfo.vehicle.frameNo = vehicle.frameNo
        cacheRecordInfo.vehicle.singeinDate = vehicle.singeinDate
        cacheRecordInfo.vehicle.engineNo = vehicle.engineNo
        arr.forEach(item => {
          cacheRecordInfo.owner[item] = owner[item] || ''
        })
        if (this.insuredTips) {
          arr.forEach(item => {
            cacheRecordInfo.insured[item] = insured[item] || ''
          })
        }
        if (this.applicantTips) {
          arr.forEach(item => {
            cacheRecordInfo.applicant[item] = applicant[item] || ''
          })
        }
        imgData.forEach(img => {
          const code = img.typePath.split('|')[2] || img.typePath.split('|')[1]
          const fileName = img.fileOrgName
          if (code === 'S001_0601' && fileName.indexOf('just') !== -1) {
            cacheRecordInfo.owner.justSrc = img.fileRealURL
            cacheRecordInfo.owner.justName = fileName
          }
          if (code === 'S001_0601' && fileName.indexOf('back') !== -1) {
            cacheRecordInfo.owner.backSrc = img.fileRealURL
            cacheRecordInfo.owner.backName = fileName
          }
          if (code === 'S001_0701' && fileName.indexOf('just') !== -1) {
            cacheRecordInfo.vehicle.justSrc = img.fileRealURL
            cacheRecordInfo.vehicle.justName = fileName
          }
          if (code === 'S001_0701' && fileName.indexOf('back') !== -1) {
            cacheRecordInfo.vehicle.backSrc = img.fileRealURL
            cacheRecordInfo.vehicle.backName = fileName
          }
          if (this.insuredTips) {
            if (code === 'S001_0401' && fileName.indexOf('just') !== -1) {
              cacheRecordInfo.insured.justSrc = img.fileRealURL
              cacheRecordInfo.insured.justName = fileName
            }
            if (code === 'S001_0401' && fileName.indexOf('back') !== -1) {
              cacheRecordInfo.insured.backSrc = img.fileRealURL
              cacheRecordInfo.insured.backName = fileName
            }
          }
          if (this.applicantTips) {
            if (code === 'S001_0301' && fileName.indexOf('just') !== -1) {
              cacheRecordInfo.applicant.justSrc = img.fileRealURL
              cacheRecordInfo.applicant.justName = fileName
            }
            if (code === 'S001_0301' && fileName.indexOf('back') !== -1) {
              cacheRecordInfo.applicant.backSrc = img.fileRealURL
              cacheRecordInfo.applicant.backName = fileName
            }
          }
        })
        this.setCacheRecordInfo(utils.deepClone(cacheRecordInfo))
        this.$router.push({path: '/base_msg_ocr'});
      })
    },
    isSameOwner() {
      const applicant = this.saveData.applicant
      const owner = this.saveData.owner
      const insured = this.saveData.insured
      if ((applicant.name && applicant.identifyNumber ) && (applicant.name !== owner.name || applicant.identifyNumber !== owner.identifyNumber)) {
        const applicantTips = applicant.name + ' ' + applicant.identifyNumber
        this.setApplicantTips(applicantTips)
      }
      if ((insured.name && insured.identifyNumber) && (insured.name !== owner.name || insured.identifyNumber !== owner.identifyNumber)) {
        const insuredTips = insured.name + ' ' + insured.identifyNumber
        this.setInsuredTips(insuredTips)
      }
    },
    quoteData(){
      let source=window.localStorage.getItem('Source');
      if(this.isTemp && source=='XZB'){
        this.showDialog=false;
        this.setQuoteInfo(this.saveData);
        this.setNewCar(this.newCar);
        this.setApplicantEmail(this.saveData.applicant.email); // 保留上一次投保邮箱 
        if (this.isSdjg) {
          this.$router.push({path: '/base_msg_sd'});
          return;
        }
        if (this.isHc) {
          this.$router.push({path: '/base_msg_hc'});
          return;
        }
        if(this.switchList.ocrInsuredSwitch){
          this.isSameOwner()
          this.getImgData()
          return ; 
        }
        this.$router.push({path: '/base_msg'});
      }else{
        window.location.href='/eb-web/dist/renewal-of-insurance/#/login?licenseNo='+this.carBeans.vehicle.licenseNo + `&skipReason=${this.skipReason}`;
      }
    },
    getCarInfo() {
      var params = {
        token: memberModule.getToken(),
      };
      $http.userCarInfo({
        data: params,
      }).then(res => {
        if (!res.errCode) {
          this.$store.commit('setCarInfo', res.data || {});
          Object.assign(this.carBeans.vehicle, res.data);
          this.setLicenseKB(this.carBeans.vehicle.licenseNo);
          this.isAutoEditLicenseNo = true;//自动填充车牌
          this.setCarBeans();
        }else{
          //自动获取上次报价车牌
          let carCache=window.sessionStorage.getItem('carCache') || this.licenseNo;
          if(carCache){
            let licenseNo =  carCache !== '*-*' ? carCache : '';
            this.setLicenseKB(licenseNo);
          }
        }
      });
    },
    setOwnerInfo(){
      let certificateDate = this.carBeans.insured.idcartType === '120001' ? (this.carBeans.insured.certificateDate || '') : '';
      let birthday = this.carBeans.insured.idcartType === '120001' ? (this.carBeans.insured.birthday || '') : '';
      let userName = this.carBeans.insured.idcartType === '120001' ? (this.carBeans.insured.userName || '') : '';
      this.carBeans.owner.name = this.carBeans.vehicle.owner|| userName ||'';
      this.carBeans.owner.mobilePhone = this.carBeans.insured.mobile || '';
      this.carBeans.owner.identifyNumber = this.carBeans.insured.idcartType === '120001' ? (this.carBeans.insured.idcartNo || '') : '';
      this.carBeans.applicant.email = this.carBeans.insured.email || '';
      this.carBeans.owner.birthday = birthday ||'';
      this.carBeans.owner.identifyExpiry = certificateDate ==='Infinity' ? '9999-12-31' : certificateDate ;
      this.carBeans.owner.identifyLongValid = certificateDate ==='Infinity' ? '1' : '0';
    },
    setCarBeans() {
      this.carBeans.vehicle.frameNo = this.carBeans.vehicle.vinno || '';
      this.carBeans.vehicle.singeinDate = this.carBeans.vehicle.enrollDate || '';
      this.newCar = this.carBeans.vehicle.newVehicleFlag === '1';
      this.carBeans.vehicle.brandName = '';
      

    },
    getLocation() {
      window.qqMapGeolocation = () => {
        utils.qqMapGeolocation().then(() => {
            this.loadLocation()
        }).catch(() => {
          Loading.hide();
        })
      }
      if (utils.isHaApp()) {
        const callback = function() {
          window.uni.postMessage({ 
            data: {
              action: 'checkPermission',
              options: {
                name: 'location',
                callback: 'qqMapGeolocation'
              }
            }
          })
        }
        if (window.uni) callback()
        else document.addEventListener('UniAppJSBridgeReady', callback)
      } else {
        window.qqMapGeolocation()
      }  
    },
    // 锚点跳到指定位置
    goAnchor(index) {
      this.$set(this,'tabActive',index);
      this.$set(this,'isNotClick',false)
      let target = document.getElementById('type_'+index);
      let type_tab = document.getElementById('type_tab');
      window.scrollTo({
         top: target.offsetTop - type_tab.clientHeight,
         behavior: "smooth"
      })
      

    },
    //页面滚动到特定区域，对应的Tab栏选中
    scrollToActiveTap(e) {
      if(this.$route.fullPath!=='/'){
        return
      }
        let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        // common_type_title元素的高度
        let title_clientHeight = document.getElementById('type_tab').clientHeight;
        let target = document.getElementById('type_0');
        let type_tab = document.getElementById('type_tab');
        const tab_offsetTop_list = [];
        let topTab_height = type_tab.clientHeight;  //tab栏元素高度
        let type_app_0_offsetTop = target.offsetTop; //type_app_0 元素距离滑动区域(IonContent)顶部的高度

        if (scrollTop > type_app_0_offsetTop - topTab_height) {
          type_tab.style.position = 'fixed';
          type_tab.style.top = '0';
          // target.style.marginTop = topTab_height+'px';
        } else {
          type_tab.style.position = 'unset';
          // type_tab.style.top = '0';
          // target.style.marginTop = '0px';
        }
        // 如果是点击滑动事件，就不往下面执行了
        if(!this.isNotClick){
          setTimeout(()=>{
            this.$set(this,'isNotClick',true)
          },2000)
          return;
        }
        //将tab的滑动范围记录起来
        for (let i = 0; i < 3; i ++) {
            let offsetTop = document.getElementById(`type_${i}`).offsetTop - title_clientHeight;
            tab_offsetTop_list.push(offsetTop);
        }
        //判断滚动条处于哪个应用菜单范围内
        for(var i = 0; i < tab_offsetTop_list.length; i++){
            var item = tab_offsetTop_list[i];
            var nextItem = tab_offsetTop_list[i+1];
            
            if(i === tab_offsetTop_list.length-1){
                nextItem = 99999999;
            }
            if((scrollTop >= item && scrollTop < nextItem)){ //滚动条处于哪个应用菜单范围内
                this.$set(this,'tabActive',i);
                break;
            }
        }
    },

    // 跳链接
    toLink(link) {
        window.location.href = link
    },
    // // 滚动事件
    // handleScolll(el) {
    //     const homeEl = document.querySelector('.home');
    //     const tabEl = homeEl.querySelector('.tab');
    //     const pos = homeEl.getBoundingClientRect().top;
    //     let positionValue = 'unset';
    //     if (pos < -this.tabElOffsetTop) {
    //         positionValue = 'fixed';
    //     } else {
    //         positionValue = 'unset';
    //     }
    //     tabEl.style.position = positionValue;
    //     tabEl.style.top = '0px';
    // }
    toPrivacy(){
      this.$router.push({path: '/privacy'}); 
    },
    // 陕西机构不是陕开头的牌照跳转
    routeJump() {
      this.isCanDept = false
      window.location.href = 'https://m.sinosafe.com.cn/customer/claim/shop'
    },
    queryDeptByCity() {
      let cityCode = this.value&&this.value.length ? this.value[2] : '';
      let query = {
        cityCode: cityCode,
      };
      if(!cityCode){
        return ;
      }
      $get.queryDeptByCity({
        query: query,
      }).then(res => {
        if(res.resultCode==='0'){
          let vhlNoPre = res.result&&res.result.vhlNoPre;
          //如果不是手动选择地址，且有车牌号就退出
          if(!this.isManualSelect && this.carBeans.vehicle.licenseNo &&!this.isSdjg){
            return;
          }
          if(vhlNoPre){
            this.isAutoEditLicenseNo = false;//自动填充车牌
            window.sessionStorage.setItem('offSiteVehicleLicenseNo', vhlNoPre);
            if (this.isSdjg) return
            this.setLicenseKB(vhlNoPre);
          }  
        }else if(!res.errorMsg){
          Toast(res.errorMsg)
        }
      });
    },    
    // 已阅读处理
    handleCalculatingPremiun() {
      let self = this;
      utils.stopVideo(this.flowId).then(()=>{
          utils.startVideo()
      })
      this.$set(this, 'isShowTips', false);
      // this.$set(this, 'isGoLogin', true);

      memberModule.checkLogin((userInfo) => {
        // 会员登录之后 
        // 公共系统埋点统计
        let recordCode = this.isHaApp ? 'gEmS4zbaaGYpbCsTrIsje' : 'xBHY98f0sF8zVbh5cXnIs'
        $http.addRecord({data: { recordCode }})
        // 不做任何操作 
        this.$store.commit('setUserInfo', userInfo);
        Object.assign(this.carBeans.insured, userInfo);
        // this.initToGetFlowId();
        this.setOwnerInfo();
        this.getCarInfo();
        this.queryLocation(); // 获取定位
        if (this.isSdjg) {
          this.getSdQuoteData()
        }
      }, () => {
        // 没登录就跳转会员登录
        this.isGoLogin = true;
        this.$set(this,'isGoLogin',true);
        this.timeEvent = setInterval(() => {
          self.$set(self, 'toLoginSecond', self.toLoginSecond - 1)
          if (self.toLoginSecond < 1) {
            self.handleGoLogin();
          }
        }, 1000)
      },()=>{},{ headers: { 'X-Desensitize': false } });
    },
    // 立即登录处理
    handleGoLogin() {
      let toUrl = window.location.href;
      clearInterval(this.timeEvent);
      this.$set(this, 'isGoLogin', false);
      if (window.location.hash.split("?")[1]) {
        toUrl = toUrl + '&hasLogin=' + true;
      } else {
        toUrl = toUrl + '?hasLogin=' + true;
      }
      memberModule.toLogin(toUrl);
    },
    queryLocation() {
      // 获取定位
      if (this.cityList.length == 0) {
        $get.wxCityQuery()
          .then(res => {
            if (res.resultCode == '0') {
              this.addressData = res.result;
              this.getLocation();
              // 山东营运兼容省市区接口请求过慢
              if (this.isSdjg && this.sdReqDone && !this.value.length && this.addressData.length) {
                const districtList = this.addressData.filter(item => item.parent === this.carBeans.base.cityCode)
                if (districtList.length) {
                  const districtCode = districtList[0].value
                  this.sdCityId = districtCode
                  this.value = ['370000', this.carBeans.base.cityCode, districtCode]
                }
              }
            }
          });
      } else {
        this.addressData = this.cityList;
        if (!this.value.length) {
          this.value = this.cityGroup;
        }
      }
    },
    // 获取山东营运车投保数据
    async getSdQuoteData() {
      try {
        const { signature, vehicleid } = this.urlParams
        const option = {
          query: {
            signature,
            vehicleid
          }
        }
        const res = await $get.getVehicleInfo(option)
        if (res.resultCode == '0' && res.result) {
          if (this.addressData.length) {
            const districtList = this.addressData.filter(item => item.parent === res.result.base.cityCode)
            if (districtList.length) {
              const districtCode = districtList[0].value
              this.sdCityId = districtCode
              this.value = ['370000', res.result.base.cityCode, districtCode]
            }
          }
          this.sdReqDone = true
          this.carBeans = utils.deepClone(res.result)
          // 保存投保数据到仓库
          this.setQuoteInfo(utils.deepClone(res.result))
          this.setSdQuoteInfo(utils.deepClone(res.result))
          this.setLicenseKB(this.carBeans.vehicle.licenseNo);
          // 如果车牌是*-*，勾选"我是新车未上牌"，同时设置新车标志到仓库
          if (this.carBeans.vehicle.licenseNo==='*-*') {
            this.newCar = true;
            this.setNewCar(this.newCar);
          }
          // 展示跳转华安保险公众号订单中心弹窗
          // submit: true有提核的订单 false无已提核的订单
          if (res.result.submit) {
            this.isShowSdjgMember = true;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 山东营运车: 跳转到华安保险公众号订单中心，查看订单或者支付
    goMemberCenter() {
      this.isShowSdjgMember = false;
      window.location.href = `/eb-web/vue/member/`;
    },
    // 山东营运车: 关闭弹窗，继续走投保流程
    goContinue() {
      this.isShowSdjgMember = false;
    }
  },
  // beforeRouteEnter (to, from, next) {
  //   next((vm)=>{
  //     if(from.fullPath === '/privacy'){
  //       vm.$set(vm,'isShowTips',false)
  //     }
  //   })
  // }
}
